<!--
 * @Description: 需求管理 添加
 * @Author: PF
 * @Date: 2023-12-19 09:53:49
 * @LastEditors: PF
 * @LastEditTime: 2026-10-13 09:37:36
-->
<template>
  <el-container>
    <el-main class="pl0 pr0">
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="106px">
        <el-row gutter="10">
          <el-col :span="8">
            <el-form-item label="标题" prop="bt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.bt" />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="所属菜单">
              <span>{{ props.indRow.sscdmc || '首页' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" prop="lx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.lx" clearable filterable>
                <el-option v-for="(item, index) in xqlxData.list" :key="index" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提出人" prop="tcr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.tcr" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提出时间" prop="tcsj">
              <el-date-picker v-model="ruleForm.tcsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="解决人" prop="jjr">
              <el-input v-model="ruleForm.jjr" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="要求解决时间" prop="yqjjsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.yqjjsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="解决状态" prop="jjzt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-radio-group v-model="ruleForm.jjzt" clearable filterable style="height: auto;">
                <el-radio  v-for="item in jjztData.list" :key="item.value" :value="item.value">{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="ruleForm.jjzt === jjztData.yjj">
            <el-form-item label="实际解决时间" prop="jjsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.jjsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述 " prop="ms">
              <ueditor v-model:value="ruleForm.ms" :row="{height:500}" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer class="el-dialog__footer">
      <div class="dialog-footer">
        <div></div>
        <div class="footer_but">
          <el-button type="primary" @click="submit(1)">保存并新增</el-button>
          <el-button type="primary" @click="submit(2)">保存</el-button>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script setup>
import { ref, watch, unref, defineProps, defineEmits } from 'vue'
import { actionPost, loadSelect } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { getDate } from '@/utils/index.js'
import ueditor from '@/components/ueditor.vue'

const props = defineProps({
  indRow: { type: Object, required: false }
})
const emits = defineEmits(['ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({ tcsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm') })

// 需求类型
const xqlxData = ref({ list: [] })
const initXuQiuLeiXing = () => {
  loadSelect({ url: '/api/v2/sys/xuqiu/xuqiuleixing', data: xqlxData, loadSuccess: function (res) { ruleForm.value.lx = res.data.xq } })
}
// 解决状态
const jjztData = ref({ list: [] })
const initJieJueZhuangTai = () => {
  loadSelect({ url: '/api/v2/sys/xuqiu/jiejuezhuangtai', data: jjztData, loadSuccess: function () { ruleForm.value.jjzt = 0 } })
}

watch(
  () => props.indRow,
  () => {
    if (props.indRow) {
      ruleForm.value = {
        tcsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm'),
        xtid: props.indRow.xtid,
        menuid: props.indRow.menuid,
        xtsy: props.indRow.xtsy
      }
      initXuQiuLeiXing()
      initJieJueZhuangTai()
    }
  },
  { deep: true, immediate: true }
)
// 提交
const submit = async (val) => {
  const forms = unref(ruleFormRef)
  if (!forms) return
  await forms.validate()
  actionPost({ url: '/api/v2/sys/xuqiu', data: ruleForm.value }).then(res => {
    if (res.code === 200) {
      successPrompt(res.message)
      ruleForm.value = {
        tcsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm')
      }
      initXuQiuLeiXing()
      initJieJueZhuangTai()
      if (val === 2) {
        emits('ReturnData', true)
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
